import React from 'react';
import { shape, string, arrayOf, bool } from 'prop-types';
import { Link } from 'react-router-dom';

function LinksGroup({ groupStyle, links }) {
  return (
    <div className={groupStyle}>
      {links.map(({ to, text, style, id, href, isTitleHeader }) =>
        to ? (
          <Link key={text} className={style} to={to} id={id}>
            {text}
          </Link>
        ) : (
          <a
            key={text}
            className={style}
            {...(isTitleHeader ? {} : { href, target: '_blank' })}
            rel="noopener noreferrer"
            id={id}>
            {text}
          </a>
        )
      )}
    </div>
  );
}

LinksGroup.defaultProps = {
  groupStyle: '',
  isTitleHeader: false
};

LinksGroup.propTypes = {
  links: arrayOf(
    shape({
      className: string,
      text: string.isRequired,
      to: string
    })
  ).isRequired,
  groupStyle: string,
  isTitleHeader: bool
};

export default LinksGroup;
